var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c("loading", {
        attrs: {
          active: _vm.isLoading,
          "enforce-focus": false,
          loader: "dots",
        },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c("div", { staticClass: "card search-card" }, [
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "form-row" }, [
            _c("div", { staticClass: "col-sm-3 col-md-3" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "" } }, [_vm._v("面談日期")]),
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      "picker-options": _vm.pickerOptions,
                      "value-format": "yyyy-MM-dd",
                      type: "daterange",
                      placeholder: "yyyy-mm-dd",
                      disabled: _vm.activeName !== "third",
                    },
                    model: {
                      value: _vm.search.InvitationTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.search, "InvitationTime", $$v)
                      },
                      expression: "search.InvitationTime",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "col-sm-3 col-md-3" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "" } }, [_vm._v("時段")]),
                  _c(
                    "el-select",
                    {
                      staticStyle: { display: "block" },
                      attrs: { placeholder: "請選擇", filterable: "" },
                      model: {
                        value: _vm.search.TimePeriod,
                        callback: function ($$v) {
                          _vm.$set(_vm.search, "TimePeriod", $$v)
                        },
                        expression: "search.TimePeriod",
                      },
                    },
                    _vm._l(_vm.timePeriodOptions, function (option) {
                      return _c("el-option", {
                        key: option.Value,
                        attrs: { label: option.Text, value: option.Value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "col-sm-3 col-md-3" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", { attrs: { for: "" } }, [_vm._v("應徵職務")]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.search.ManpowerDemandName,
                      expression: "search.ManpowerDemandName",
                      modifiers: { trim: true },
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", placeholder: "請輸入關鍵字" },
                  domProps: { value: _vm.search.ManpowerDemandName },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.search,
                        "ManpowerDemandName",
                        $event.target.value.trim()
                      )
                    },
                    blur: function ($event) {
                      return _vm.$forceUpdate()
                    },
                  },
                }),
              ]),
            ]),
            _c("div", { staticClass: "col-sm-3 col-md-3" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", { attrs: { for: "" } }, [_vm._v("招募窗口")]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.search.ContactPersonKeyword,
                      expression: "search.ContactPersonKeyword",
                      modifiers: { trim: true },
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", placeholder: "請輸入關鍵字" },
                  domProps: { value: _vm.search.ContactPersonKeyword },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.search,
                        "ContactPersonKeyword",
                        $event.target.value.trim()
                      )
                    },
                    blur: function ($event) {
                      return _vm.$forceUpdate()
                    },
                  },
                }),
              ]),
            ]),
            _c("div", { staticClass: "col-sm-3 col-md-3" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", { attrs: { for: "" } }, [_vm._v("姓名")]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.search.NameKeyword,
                      expression: "search.NameKeyword",
                      modifiers: { trim: true },
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", placeholder: "請輸入關鍵字" },
                  domProps: { value: _vm.search.NameKeyword },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.search,
                        "NameKeyword",
                        $event.target.value.trim()
                      )
                    },
                    blur: function ($event) {
                      return _vm.$forceUpdate()
                    },
                  },
                }),
              ]),
            ]),
            _c("div", { staticClass: "col-sm-3 col-md-3" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", { attrs: { for: "" } }, [_vm._v("身分證關鍵字")]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.search.IdNoKeyword,
                      expression: "search.IdNoKeyword",
                      modifiers: { trim: true },
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", placeholder: "請輸入關鍵字" },
                  domProps: { value: _vm.search.IdNoKeyword },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.search,
                        "IdNoKeyword",
                        $event.target.value.trim()
                      )
                    },
                    blur: function ($event) {
                      return _vm.$forceUpdate()
                    },
                  },
                }),
              ]),
            ]),
            _c("div", { staticClass: "col-sm-3 col-md-3" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  staticStyle: { "margin-top": "30px", "margin-right": "5px" },
                  attrs: { type: "button" },
                  on: { click: _vm.getCheckIn },
                },
                [_vm._v(" " + _vm._s(_vm.i18n("BUTTON.SEARCH")) + " ")]
              ),
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary",
                  staticStyle: { "margin-top": "30px", "margin-right": "5px" },
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      _vm.search = {
                        InvitationTime: _vm.search.InvitationTime,
                        TimePeriod: 0,
                      }
                    },
                  },
                },
                [_vm._v(" 清除 ")]
              ),
            ]),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "text-right" }, [
        _vm._v("更新時間 : " + _vm._s(_vm.reloadTime)),
      ]),
      _c(
        "div",
        { staticClass: "fixed-list-item" },
        [
          _c("eva-icon", {
            attrs: { fill: "#000", name: "refresh-outline" },
            on: { click: _vm.reload },
          }),
        ],
        1
      ),
      _c(
        "el-tabs",
        {
          on: {
            "tab-click": function ($event) {
              return _vm.changeTab()
            },
          },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c("el-tab-pane", {
            attrs: { label: "當天預約到廠", name: "first" },
          }),
          _c("el-tab-pane", { attrs: { label: "臨時到廠", name: "second" } }, [
            _c(
              "div",
              { staticClass: "function-card" },
              [
                _c(
                  "span",
                  {
                    staticStyle: { cursor: "pointer" },
                    on: {
                      click: function ($event) {
                        _vm.qrCodeDialogVisible = true
                      },
                    },
                  },
                  [
                    _c("qrcode-vue", {
                      attrs: { value: _vm.QRCode, size: "100" },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "small" },
                    on: {
                      click: function ($event) {
                        return _vm.openTemporaryModal()
                      },
                    },
                  },
                  [_vm._v("新增臨時到廠")]
                ),
              ],
              1
            ),
          ]),
          _c("el-tab-pane", {
            attrs: { label: "後續預約到廠", name: "third" },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "card-list" },
        _vm._l(_vm.personList, function (person, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "p-card",
              class: {
                darken: person.endTime === null,
                "gray-card": person.Status === 1 || person.Status === 2,
              },
            },
            [
              _c("div", { staticClass: "person-info" }, [
                _c(
                  "div",
                  { staticClass: "info" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "name",
                        class: {
                          female: person.Sex === "女",
                          male: person.Sex === "男",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.showDetailModal(person)
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(person.Name) + " ")]
                    ),
                    _c("div", { staticClass: "id" }, [
                      _vm._v(_vm._s(person.MobilePhone)),
                    ]),
                    person.ArrangeTempType === 2
                      ? _c("div", { staticClass: "check-label" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.choosePersonList,
                                expression: "choosePersonList",
                              },
                            ],
                            attrs: { type: "checkbox" },
                            domProps: {
                              value: person.ArrangeTempGuid,
                              checked: Array.isArray(_vm.choosePersonList)
                                ? _vm._i(
                                    _vm.choosePersonList,
                                    person.ArrangeTempGuid
                                  ) > -1
                                : _vm.choosePersonList,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.choosePersonList,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = person.ArrangeTempGuid,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.choosePersonList = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.choosePersonList = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.choosePersonList = $$c
                                }
                              },
                            },
                          }),
                        ])
                      : _vm._e(),
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: {
                          effect: "dark",
                          content: person.ManpowerDemandName,
                          placement: "bottom",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "job" },
                          [
                            _c("eva-icon", {
                              attrs: {
                                width: "25",
                                fill: "#000",
                                name: "briefcase-outline",
                              },
                            }),
                            person.ArrangeTempType === 1
                              ? [
                                  _vm._v(
                                    " " +
                                      _vm._s(person.ManpowerDemandName) +
                                      " "
                                  ),
                                ]
                              : [_vm._v(" 尚未轉入職缺 ")],
                          ],
                          2
                        ),
                      ]
                    ),
                    person.InvitationTime
                      ? _c(
                          "div",
                          { staticClass: "job", attrs: { width: "25" } },
                          [
                            _c("eva-icon", {
                              attrs: { fill: "#000", name: "calendar-outline" },
                            }),
                            _vm._v(
                              _vm._s(_vm._f("moment")(person.InvitationTime)) +
                                " "
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "job-info" }, [
                _c(
                  "span",
                  [
                    _c("div", { staticClass: "svg-wrap" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 512 512",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M502.6 198.6l-61.25-61.25C435.4 131.4 427.3 128 418.8 128H256C220.7 128 191.1 156.7 192 192l.0065 255.1C192 483.3 220.7 512 256 512h192c35.2 0 64-28.8 64-64l.0098-226.7C512 212.8 508.6 204.6 502.6 198.6zM464 448c0 8.836-7.164 16-16 16h-192c-8.838 0-16-7.164-16-16L240 192.1c0-8.836 7.164-16 16-16h128L384 224c0 17.67 14.33 32 32 32h48.01V448zM317.7 96C310.6 68.45 285.8 48 256 48H215.2C211.3 20.93 188.1 0 160 0C131.9 0 108.7 20.93 104.8 48H64c-35.35 0-64 28.65-64 64V384c0 35.34 28.65 64 64 64h96v-48H64c-8.836 0-16-7.164-16-16V112C48 103.2 55.18 96 64 96h16v16c0 17.67 14.33 32 32 32h61.35C190 115.4 220.6 96 256 96H317.7zM160 72c-8.822 0-16-7.176-16-16s7.178-16 16-16s16 7.176 16 16S168.8 72 160 72z",
                            },
                          }),
                        ]
                      ),
                    ]),
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          placeholder: "請選擇流程",
                          disabled:
                            (person.Status !== 3 && person.Status !== 4) ||
                            person.ArrangeTempType !== 1,
                          filterable: "",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.saveFlow($event, person.ArrangeGuid)
                          },
                        },
                        model: {
                          value: person.BaseFlowGuid,
                          callback: function ($$v) {
                            _vm.$set(person, "BaseFlowGuid", $$v)
                          },
                          expression: "person.BaseFlowGuid",
                        },
                      },
                      _vm._l(_vm.flowOptions, function (item) {
                        return _c("el-option", {
                          key: item.Value,
                          attrs: {
                            label: item.Text,
                            value: item.Value,
                            disabled: !item.IsEnabled,
                          },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "span",
                  [
                    _c("div", { staticClass: "svg-wrap" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 448 512",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M272 304h-96C78.8 304 0 382.8 0 480c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32C448 382.8 369.2 304 272 304zM48.99 464C56.89 400.9 110.8 352 176 352h96c65.16 0 119.1 48.95 127 112H48.99zM224 256c70.69 0 128-57.31 128-128c0-70.69-57.31-128-128-128S96 57.31 96 128C96 198.7 153.3 256 224 256zM224 48c44.11 0 80 35.89 80 80c0 44.11-35.89 80-80 80S144 172.1 144 128C144 83.89 179.9 48 224 48z",
                            },
                          }),
                        ]
                      ),
                    ]),
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          filterable: "",
                          placeholder: "請選擇窗口",
                          disabled: person.ArrangeTempType !== 1,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.saveContact($event, person.ArrangeGuid)
                          },
                        },
                        model: {
                          value: person.ContactPersonGuid,
                          callback: function ($$v) {
                            _vm.$set(person, "ContactPersonGuid", $$v)
                          },
                          expression: "person.ContactPersonGuid",
                        },
                      },
                      _vm._l(_vm.contactOptions, function (item) {
                        return _c("el-option", {
                          key: item.Value,
                          attrs: { label: item.Text, value: item.Value },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "span",
                  [
                    _c("div", { staticClass: "svg-wrap" }, [_vm._v("H")]),
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          filterable: "",
                          placeholder: "請選擇HR主管",
                          disabled:
                            person.Status !== 3 || person.ArrangeTempType !== 1,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.setHrSupervisor(
                              $event,
                              person.ArrangeGuid
                            )
                          },
                        },
                        model: {
                          value: person.HrSupervisorId,
                          callback: function ($$v) {
                            _vm.$set(person, "HrSupervisorId", $$v)
                          },
                          expression: "person.HrSupervisorId",
                        },
                      },
                      _vm._l(_vm.contactOptions, function (item) {
                        return _c("el-option", {
                          key: item.Value,
                          attrs: { label: item.Text, value: item.Value },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "span",
                  [
                    _c("div", { staticClass: "svg-wrap" }, [_vm._v("M")]),
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          filterable: "",
                          placeholder: "請選擇面試主管",
                          disabled:
                            person.Status !== 3 || person.ArrangeTempType !== 1,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.setManagerSupervisor(
                              $event,
                              person.ArrangeGuid
                            )
                          },
                        },
                        model: {
                          value: person.ManagerSupervisorId,
                          callback: function ($$v) {
                            _vm.$set(person, "ManagerSupervisorId", $$v)
                          },
                          expression: "person.ManagerSupervisorId",
                        },
                      },
                      _vm._l(_vm.contactOptions, function (item) {
                        return _c("el-option", {
                          key: item.Value,
                          attrs: { label: item.Text, value: item.Value },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c("span", [
                  _c("div", { staticClass: "svg-wrap" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          viewBox: "0 0 512 512",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M232 120C232 106.7 242.7 96 256 96C269.3 96 280 106.7 280 120V243.2L365.3 300C376.3 307.4 379.3 322.3 371.1 333.3C364.6 344.3 349.7 347.3 338.7 339.1L242.7 275.1C236 271.5 232 264 232 255.1L232 120zM256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0zM48 256C48 370.9 141.1 464 256 464C370.9 464 464 370.9 464 256C464 141.1 370.9 48 256 48C141.1 48 48 141.1 48 256z",
                          },
                        }),
                      ]
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "info-time" },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm._f("momentTime")(person.InvitationTime)) +
                          "/ "
                      ),
                      person.CheckInTime !== null
                        ? [
                            _vm._v(
                              _vm._s(_vm._f("momentTime")(person.CheckInTime))
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "button-wrap text-center" },
                  [
                    person.Status === 3
                      ? [
                          person.ArrangeTempType === 1
                            ? [
                                !person.CheckInTime
                                  ? _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-danger btn-sm mr-1",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.openCancelModal(person)
                                          },
                                        },
                                      },
                                      [_vm._v(" 取消 ")]
                                    )
                                  : _vm._e(),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-info btn-sm mr-1",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openReArrangeModal(person)
                                      },
                                    },
                                  },
                                  [_vm._v(" 改期 ")]
                                ),
                                _vm.activeName !== "third"
                                  ? _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-primary btn-sm",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.checkIn(person)
                                          },
                                        },
                                      },
                                      [_vm._v(" 報到 ")]
                                    )
                                  : _vm._e(),
                              ]
                            : _vm._e(),
                          person.ArrangeTempType === 2
                            ? _c("el-alert", {
                                attrs: {
                                  closable: false,
                                  center: "",
                                  title: "尚未轉入職缺",
                                  type: "info",
                                },
                              })
                            : _vm._e(),
                          person.ArrangeTempType === 3
                            ? _c("el-alert", {
                                attrs: {
                                  closable: false,
                                  center: "",
                                  title: "沒有對應履歷",
                                  type: "info",
                                },
                              })
                            : _vm._e(),
                        ]
                      : _vm._e(),
                    person.Status === 6
                      ? _c("el-alert", {
                          attrs: {
                            closable: false,
                            center: "",
                            title: "已結案",
                            type: "success",
                          },
                        })
                      : _vm._e(),
                    person.Status === 4 || person.Status === 5
                      ? _c("el-alert", {
                          attrs: {
                            closable: false,
                            center: "",
                            title: "已報到",
                            type: "success",
                          },
                        })
                      : _vm._e(),
                    person.Status === 1
                      ? _c(
                          "el-alert",
                          {
                            attrs: {
                              closable: false,
                              center: "",
                              type: "info",
                            },
                          },
                          [
                            _vm._v(
                              " 已改期-" +
                                _vm._s(
                                  _vm._f("momentDateTime")(person.ReArrangeDate)
                                ) +
                                " "
                            ),
                          ]
                        )
                      : _vm._e(),
                    person.Status === 2
                      ? _c("el-alert", {
                          attrs: {
                            closable: false,
                            center: "",
                            title: "已取消",
                            type: "error",
                          },
                        })
                      : _vm._e(),
                  ],
                  2
                ),
              ]),
            ]
          )
        }),
        0
      ),
      _vm.personList.length === 0 ? _c("div", [_vm._v("暫無資料")]) : _vm._e(),
      _c(
        "div",
        {
          staticClass: "select-count",
          class: { showing: _vm.choosePersonList.length > 0 },
        },
        [
          _c("img", {
            attrs: { src: require("@/assets/img/select_count.png"), alt: "" },
          }),
          _c("div", { staticClass: "select-count-inner" }, [
            _vm._v(" 已選擇" + _vm._s(_vm.choosePersonList.length) + "位 "),
            _c(
              "a",
              {
                staticClass: "edit-btn",
                attrs: { href: "javascript:void(0)" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.openMatchJobModal.apply(null, arguments)
                  },
                },
              },
              [
                _c("eva-icon", {
                  attrs: { name: "share-outline", fill: "#FFF" },
                }),
                _c("span", [_vm._v("轉入職缺")]),
              ],
              1
            ),
            _c(
              "a",
              {
                staticClass: "clear-btn",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.clearSelect.apply(null, arguments)
                  },
                },
              },
              [_vm._v("清除")]
            ),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "matchJobModal",
            tabindex: "-1",
            "data-backdrop": "static",
          },
        },
        [
          _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
            _c(
              "div",
              { staticClass: "modal-content" },
              [
                _c("ValidationObserver", {
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ handleSubmit }) {
                        return [
                          _c(
                            "form",
                            {
                              on: {
                                submit: function ($event) {
                                  $event.preventDefault()
                                  return handleSubmit(_vm.matchJobManagement)
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "modal-header" }, [
                                _c("span", [_vm._v("轉入職缺")]),
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass: "modal-body",
                                  staticStyle: { height: "500px" },
                                },
                                [
                                  _c("label", { attrs: { for: "" } }, [
                                    _c("span", { staticClass: "mark" }, [
                                      _vm._v("*"),
                                    ]),
                                    _vm._v("選擇職缺："),
                                  ]),
                                  _c("ValidationProvider", {
                                    ref: "matchDemandId",
                                    attrs: { rules: "required" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c(
                                                "el-select",
                                                {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: {
                                                    filterable: "",
                                                    clearable: "",
                                                    placeholder: "請選擇",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.transformModal
                                                        .ManpowerDemandNo,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.transformModal,
                                                        "ManpowerDemandNo",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "transformModal.ManpowerDemandNo",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.openingList,
                                                  function (item) {
                                                    return _c("el-option", {
                                                      key: item.ManpowerDemandNo,
                                                      attrs: {
                                                        label:
                                                          item.ManpowerDemandNo +
                                                          "-" +
                                                          item.ManpowerDemandName,
                                                        value:
                                                          item.ManpowerDemandNo,
                                                      },
                                                    })
                                                  }
                                                ),
                                                1
                                              ),
                                              errors[0]
                                                ? _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "text-danger",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(errors[0]) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _c("label", { attrs: { for: "" } }, [
                                    _vm._v("面談流程"),
                                  ]),
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        filterable: "",
                                        clearable: "",
                                        placeholder: "請選擇流程",
                                      },
                                      model: {
                                        value: _vm.transformModal.BaseFlowGuid,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.transformModal,
                                            "BaseFlowGuid",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "transformModal.BaseFlowGuid",
                                      },
                                    },
                                    _vm._l(_vm.flowOptions, function (item) {
                                      return _c("el-option", {
                                        key: item.Value,
                                        attrs: {
                                          label: item.Text,
                                          value: item.Value,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                  _c("label", { attrs: { for: "" } }, [
                                    _vm._v("招募窗口"),
                                  ]),
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        filterable: "",
                                        clearable: "",
                                        placeholder: "請選擇",
                                      },
                                      model: {
                                        value:
                                          _vm.transformModal.ContactPersonGuid,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.transformModal,
                                            "ContactPersonGuid",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "transformModal.ContactPersonGuid",
                                      },
                                    },
                                    _vm._l(_vm.contactOptions, function (item) {
                                      return _c("el-option", {
                                        key: item.Value,
                                        attrs: {
                                          label: item.Text,
                                          value: item.Value,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                  _c("label", { attrs: { for: "" } }, [
                                    _c("span", { staticClass: "mark" }, [
                                      _vm._v("*"),
                                    ]),
                                    _vm._v("HR主管"),
                                  ]),
                                  _c("ValidationProvider", {
                                    ref: "HrSupervisorGuid",
                                    attrs: { rules: "required" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c(
                                                "el-select",
                                                {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: {
                                                    filterable: "",
                                                    clearable: "",
                                                    placeholder: "請選擇",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.transformModal
                                                        .HrSupervisorGuid,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.transformModal,
                                                        "HrSupervisorGuid",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "transformModal.HrSupervisorGuid",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.contactOptions,
                                                  function (item) {
                                                    return _c("el-option", {
                                                      key: item.Value,
                                                      attrs: {
                                                        label: item.Text,
                                                        value: item.Value,
                                                      },
                                                    })
                                                  }
                                                ),
                                                1
                                              ),
                                              errors[0]
                                                ? _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "text-danger",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(errors[0]) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _c("label", { attrs: { for: "" } }, [
                                    _vm._v("面試主管"),
                                  ]),
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        filterable: "",
                                        clearable: "",
                                        placeholder: "請選擇",
                                      },
                                      model: {
                                        value:
                                          _vm.transformModal
                                            .ManagerSupervisorGuid,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.transformModal,
                                            "ManagerSupervisorGuid",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "transformModal.ManagerSupervisorGuid",
                                      },
                                    },
                                    _vm._l(_vm.contactOptions, function (item) {
                                      return _c("el-option", {
                                        key: item.Value,
                                        attrs: {
                                          label: item.Text,
                                          value: item.Value,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "modal-footer" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-secondary",
                                    attrs: {
                                      type: "button",
                                      "data-dismiss": "modal",
                                    },
                                  },
                                  [_vm._v(" 取消 ")]
                                ),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-success",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return handleSubmit(
                                          _vm.matchJobManagement
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(" 確定 ")]
                                ),
                              ]),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "cancelModal",
            tabindex: "-1",
            "data-backdrop": "static",
          },
        },
        [
          _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
            _c("div", { staticClass: "modal-content" }, [
              _vm._m(0),
              _c("div", { staticClass: "modal-body" }, [
                _c("div", { staticClass: "p-card" }, [
                  _c("div", { staticClass: "person-info" }, [
                    _c("div", { staticClass: "info" }, [
                      _c("div", { staticClass: "name" }, [
                        _vm._v(_vm._s(_vm.currentPerson.Name)),
                      ]),
                      _c("div", { staticClass: "id" }, [
                        _vm._v(_vm._s(_vm.currentPerson.MobilePhone)),
                      ]),
                      _c("div", { staticClass: "job" }, [
                        _vm._v(_vm._s(_vm.currentPerson.ManpowerDemandName)),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "job-info" }, [
                    _c(
                      "span",
                      [
                        _c("div", { staticClass: "svg-wrap" }, [
                          _c(
                            "svg",
                            {
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 512 512",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM124.1 339.9c-5.5-5.5-5.5-14.3 0-19.8l154-154c5.5-5.5 14.3-5.5 19.8 0s5.5 14.3 0 19.8l-154 154c-5.5 5.5-14.3 5.5-19.8 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z",
                                },
                              }),
                            ]
                          ),
                        ]),
                        _c(
                          "el-select",
                          {
                            on: { change: _vm.findParentGuid },
                            model: {
                              value: _vm.currentPerson.CancelSecondGuid,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.currentPerson,
                                  "CancelSecondGuid",
                                  $$v
                                )
                              },
                              expression: "currentPerson.CancelSecondGuid",
                            },
                          },
                          _vm._l(_vm.cancelOptions, function (group) {
                            return _c(
                              "el-option-group",
                              { key: group.Guid, attrs: { label: group.Name } },
                              _vm._l(group.Children, function (item) {
                                return _c("el-option", {
                                  key: item.Guid,
                                  attrs: { label: item.Name, value: item.Guid },
                                })
                              }),
                              1
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "span",
                      [
                        _c("div", { staticClass: "svg-wrap" }, [
                          _c(
                            "svg",
                            {
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 512 512",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM124.1 339.9c-5.5-5.5-5.5-14.3 0-19.8l154-154c5.5-5.5 14.3-5.5 19.8 0s5.5 14.3 0 19.8l-154 154c-5.5 5.5-14.3 5.5-19.8 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z",
                                },
                              }),
                            ]
                          ),
                        ]),
                        _c("el-input", {
                          attrs: { placeholder: "請輸入取消原因" },
                          model: {
                            value: _vm.currentPerson.CancelReason,
                            callback: function ($$v) {
                              _vm.$set(_vm.currentPerson, "CancelReason", $$v)
                            },
                            expression: "currentPerson.CancelReason",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    attrs: { type: "reset", "data-dismiss": "modal" },
                  },
                  [_vm._v(" 關閉 ")]
                ),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: { type: "reset" },
                    on: {
                      click: function ($event) {
                        return _vm.cancelInterview()
                      },
                    },
                  },
                  [_vm._v(" 儲存 ")]
                ),
              ]),
            ]),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "interviewMailModal",
            "data-focus": "false",
            "data-keyboard": "false",
            "data-backdrop": "static",
          },
        },
        [
          _c(
            "div",
            { staticClass: "modal-dialog modal-dialog-scrollable" },
            [
              _c("ValidationObserver", {
                ref: "currentPersonForm",
                staticClass: "modal-content",
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ handleSubmit, reset }) {
                      return [
                        _c("div", { staticClass: "letter-modal" }, [
                          _c(
                            "div",
                            { staticClass: "note-wrap" },
                            [
                              _c("div", { staticClass: "letter-title" }, [
                                _vm._v("改期邀約"),
                              ]),
                              [
                                _c("div", { staticClass: "note-title" }, [
                                  _vm._v("可動態套入信件內容，請參考以下參數"),
                                ]),
                                _c("div", { staticClass: "note-table" }, [
                                  _vm.mailParameters
                                    ? _c(
                                        "table",
                                        _vm._l(
                                          _vm.mailParameters,
                                          function (parameter, index) {
                                            return _c("tr", { key: index }, [
                                              _c("th", [
                                                _vm._v(
                                                  _vm._s(
                                                    parameter.MailParameterName
                                                  )
                                                ),
                                              ]),
                                              _c("td", [
                                                _c("span", [_vm._v(" {{")]),
                                                _vm._v(
                                                  _vm._s(
                                                    parameter.MailParameterCode
                                                  )
                                                ),
                                                _c("span", [_vm._v("}} ")]),
                                              ]),
                                            ])
                                          }
                                        ),
                                        0
                                      )
                                    : _vm._e(),
                                ]),
                              ],
                            ],
                            2
                          ),
                          _c(
                            "form",
                            {
                              on: {
                                reset: function ($event) {
                                  $event.preventDefault()
                                  return reset.apply(null, arguments)
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "modal-content border-0" },
                                [
                                  _c(
                                    "perfect-scrollbar",
                                    { staticClass: "modal-body" },
                                    [
                                      _c("div", { staticClass: "form-group" }, [
                                        _c("label", { attrs: { for: "" } }, [
                                          _c(
                                            "span",
                                            { staticStyle: { color: "red" } },
                                            [_vm._v("*")]
                                          ),
                                          _vm._v("改期日期："),
                                        ]),
                                        _c(
                                          "div",
                                          { staticStyle: { display: "flex" } },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  flex: "1",
                                                  "min-width": "1px",
                                                  position: "relative",
                                                  "margin-right": "5px",
                                                },
                                              },
                                              [
                                                _c("ValidationProvider", {
                                                  attrs: {
                                                    name: "改期日期",
                                                    rules: "required",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function ({
                                                          errors,
                                                        }) {
                                                          return [
                                                            _c(
                                                              "el-date-picker",
                                                              {
                                                                staticStyle: {
                                                                  width: "100%",
                                                                },
                                                                attrs: {
                                                                  "picker-options":
                                                                    _vm.reArrangeDatePickerOptions,
                                                                  "value-format":
                                                                    "yyyy-MM-dd",
                                                                  format:
                                                                    "yyyy-MM-dd",
                                                                  type: "date",
                                                                  placeholder:
                                                                    "選擇日期",
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .currentPerson
                                                                      .ReArrangeDate,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.currentPerson,
                                                                        "ReArrangeDate",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "currentPerson.ReArrangeDate",
                                                                },
                                                              }
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-danger",
                                                                staticStyle: {
                                                                  position:
                                                                    "absolute",
                                                                  bottom: "0",
                                                                  right: "0",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      errors[0]
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  flex: "1",
                                                  "min-width": "1px",
                                                  position: "relative",
                                                  "border-radius": "4px",
                                                  border: "1px solid #dcdfe6",
                                                },
                                              },
                                              [
                                                _c("ValidationProvider", {
                                                  attrs: {
                                                    name: "改期時間",
                                                    rules: "required",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function ({
                                                          errors,
                                                        }) {
                                                          return [
                                                            _c("date-picker", {
                                                              staticClass:
                                                                "w-100",
                                                              attrs: {
                                                                id: "ReArrangeTime",
                                                                format: "HH:mm",
                                                                "value-type":
                                                                  "format",
                                                                type: "time",
                                                                "default-value":
                                                                  new Date().setHours(
                                                                    8,
                                                                    0,
                                                                    0,
                                                                    0
                                                                  ),
                                                                "minute-step": 10,
                                                                start: "00:00",
                                                                "end:": "23:30",
                                                                placeholder:
                                                                  "選擇時間",
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .currentPerson
                                                                    .ReArrangeTime,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.currentPerson,
                                                                      "ReArrangeTime",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "currentPerson.ReArrangeTime",
                                                              },
                                                            }),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-danger",
                                                                staticStyle: {
                                                                  position:
                                                                    "absolute",
                                                                  bottom: "0",
                                                                  right: "0",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      errors[0]
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ]),
                                      _c(
                                        "div",
                                        { staticClass: "form-group" },
                                        [
                                          _c("label", { attrs: { for: "" } }, [
                                            _vm._v("改期原因："),
                                          ]),
                                          _c(
                                            "el-select",
                                            {
                                              staticStyle: { width: "100%" },
                                              model: {
                                                value:
                                                  _vm.currentPerson
                                                    .ReArrangeGuid,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.currentPerson,
                                                    "ReArrangeGuid",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "currentPerson.ReArrangeGuid",
                                              },
                                            },
                                            _vm._l(
                                              _vm.reArrangeOptions,
                                              function (item) {
                                                return _c("el-option", {
                                                  key: item.Guid,
                                                  attrs: {
                                                    label: item.Name,
                                                    value: item.Guid,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "form-group" },
                                        [
                                          _c("label", { attrs: { for: "" } }, [
                                            _vm._v("請輸入改期原因："),
                                          ]),
                                          _c("el-input", {
                                            attrs: {
                                              placeholder: "請輸入改期原因",
                                            },
                                            model: {
                                              value:
                                                _vm.currentPerson
                                                  .ReArrangeReason,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.currentPerson,
                                                  "ReArrangeReason",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "currentPerson.ReArrangeReason",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "form-group" },
                                        [
                                          _c("label", { attrs: { for: "" } }, [
                                            _vm._v(" 單位面試主管："),
                                          ]),
                                          _c(
                                            "el-select",
                                            {
                                              staticClass: "w-100",
                                              attrs: {
                                                filterable: "",
                                                clearable: "",
                                                placeholder: "請選擇",
                                              },
                                              model: {
                                                value:
                                                  _vm.currentPerson
                                                    .InterviewSupervisor,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.currentPerson,
                                                    "InterviewSupervisor",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "currentPerson.InterviewSupervisor",
                                              },
                                            },
                                            _vm._l(
                                              _vm.supervisorOptions,
                                              function (supervisor) {
                                                return _c("el-option", {
                                                  key: supervisor.Guid,
                                                  attrs: {
                                                    label: supervisor.Name,
                                                    value: supervisor.Guid,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "form-group" },
                                        [
                                          _c("label", { attrs: { for: "" } }, [
                                            _c(
                                              "span",
                                              { staticStyle: { color: "red" } },
                                              [_vm._v("*")]
                                            ),
                                            _vm._v("HR 面試人員： "),
                                          ]),
                                          _c("ValidationProvider", {
                                            staticClass: "w-100",
                                            attrs: {
                                              rules: "required",
                                              name: "HR面試人員",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function ({ errors }) {
                                                    return [
                                                      _c(
                                                        "el-select",
                                                        {
                                                          staticClass: "w-100",
                                                          attrs: {
                                                            filterable: "",
                                                            placeholder:
                                                              "請選擇",
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.currentPerson
                                                                .InterviewHR,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.currentPerson,
                                                                "InterviewHR",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "currentPerson.InterviewHR",
                                                          },
                                                        },
                                                        _vm._l(
                                                          _vm.supervisorOptions,
                                                          function (
                                                            supervisor
                                                          ) {
                                                            return _c(
                                                              "el-option",
                                                              {
                                                                key: supervisor.Guid,
                                                                attrs: {
                                                                  label:
                                                                    supervisor.Name,
                                                                  value:
                                                                    supervisor.Guid,
                                                                },
                                                              }
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "text-danger",
                                                          staticStyle: {
                                                            "font-size": "13px",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                errors[0]
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "form-group" },
                                        [
                                          _c("ValidationProvider", {
                                            attrs: {
                                              rules: "required",
                                              name: "面談地點",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function ({ errors }) {
                                                    return [
                                                      _c(
                                                        "label",
                                                        { attrs: { for: "" } },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                color: "red",
                                                              },
                                                            },
                                                            [_vm._v("*")]
                                                          ),
                                                          _vm._v("面談地點： "),
                                                        ]
                                                      ),
                                                      _c(
                                                        "el-select",
                                                        {
                                                          staticClass: "w-100",
                                                          attrs: {
                                                            filterable: "",
                                                            placeholder:
                                                              "請選擇",
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.currentPerson
                                                                .InterviewPlace,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.currentPerson,
                                                                "InterviewPlace",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "currentPerson.InterviewPlace",
                                                          },
                                                        },
                                                        _vm._l(
                                                          _vm.interviewPlaceOptions,
                                                          function (place) {
                                                            return _c(
                                                              "el-option",
                                                              {
                                                                key: place.Guid,
                                                                attrs: {
                                                                  label:
                                                                    place.Name,
                                                                  value:
                                                                    place.Name,
                                                                },
                                                              }
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "text-danger",
                                                          staticStyle: {
                                                            "font-size": "13px",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                errors[0]
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "form-group" },
                                              [
                                                _c(
                                                  "label",
                                                  { attrs: { for: "" } },
                                                  [_vm._v("面談說明：")]
                                                ),
                                                _c("textarea", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.currentPerson
                                                          .Remark,
                                                      expression:
                                                        "currentPerson.Remark",
                                                    },
                                                  ],
                                                  staticClass:
                                                    "form-control w-100",
                                                  attrs: {
                                                    rows: "3",
                                                    maxlength: "10000",
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.currentPerson.Remark,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        _vm.currentPerson,
                                                        "Remark",
                                                        $event.target.value
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "form-group" },
                                              [
                                                _c(
                                                  "label",
                                                  { attrs: { for: "" } },
                                                  [_vm._v("附件：")]
                                                ),
                                                _c(
                                                  "el-upload",
                                                  {
                                                    staticClass: "upload-demo",
                                                    attrs: {
                                                      action: "",
                                                      "auto-upload": false,
                                                      "show-file-list": false,
                                                      "on-change":
                                                        _vm.uploadFile,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "el-button",
                                                      {
                                                        attrs: {
                                                          size: "small",
                                                          type: "primary",
                                                        },
                                                      },
                                                      [_vm._v(" 點擊上傳 ")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _vm.uploadFileList
                                                  ? _vm._l(
                                                      _vm.uploadFileList,
                                                      function (file) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            key: file.FileGuid,
                                                          },
                                                          [
                                                            _c(
                                                              "p",
                                                              {
                                                                staticStyle: {
                                                                  "margin-top":
                                                                    "20px",
                                                                  cursor:
                                                                    "pointer",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.$common.downloadFile(
                                                                        {
                                                                          fileGuid:
                                                                            file.FileGuid,
                                                                          fileType:
                                                                            file.FileContentType,
                                                                        }
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c("eva-icon", {
                                                                  attrs: {
                                                                    fill: "#000",
                                                                    name: "attach-outline",
                                                                  },
                                                                }),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        "margin-left":
                                                                          "15px",
                                                                        "vertical-align":
                                                                          "text-top",
                                                                      },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          file.FileName
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        display:
                                                                          "inline-block",
                                                                        position:
                                                                          "absolute",
                                                                        right:
                                                                          "25px",
                                                                      },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          $event.stopPropagation()
                                                                          return _vm.removeFile(
                                                                            {
                                                                              fileGuid:
                                                                                file.FileGuid,
                                                                              fileGroupGuid:
                                                                                file.FileGroupGuid,
                                                                            }
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "eva-icon",
                                                                      {
                                                                        attrs: {
                                                                          fill: "#000",
                                                                          name: "trash-2-outline",
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    )
                                                  : _vm._e(),
                                              ],
                                              2
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "form-group" },
                                              [
                                                _c(
                                                  "label",
                                                  { attrs: { for: "" } },
                                                  [_vm._v(" 信件範本： ")]
                                                ),
                                                _c(
                                                  "el-select",
                                                  {
                                                    staticClass: "w-100",
                                                    attrs: {
                                                      filterable: "",
                                                      clearable: "",
                                                      placeholder: "請選擇",
                                                    },
                                                    on: {
                                                      change:
                                                        _vm.getMailTemplateDetail,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.selectedTemplateGuid,
                                                      callback: function ($$v) {
                                                        _vm.selectedTemplateGuid =
                                                          $$v
                                                      },
                                                      expression:
                                                        "selectedTemplateGuid",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.mailTemplates,
                                                    function (template) {
                                                      return _c("el-option", {
                                                        key: template.MailTemplateGuid,
                                                        attrs: {
                                                          label:
                                                            template.MailTemplateName,
                                                          value:
                                                            template.MailTemplateGuid,
                                                        },
                                                      })
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "form-group" },
                                              [
                                                _c("ValidationProvider", {
                                                  staticClass: "w-100",
                                                  attrs: {
                                                    rules: "required",
                                                    name: "信件主旨",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function ({
                                                          errors,
                                                        }) {
                                                          return [
                                                            _c(
                                                              "label",
                                                              {
                                                                attrs: {
                                                                  for: "",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "mark",
                                                                  },
                                                                  [_vm._v("*")]
                                                                ),
                                                                _vm._v(
                                                                  "信件主旨： "
                                                                ),
                                                              ]
                                                            ),
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm
                                                                      .currentPerson
                                                                      .MailSubject,
                                                                  expression:
                                                                    "currentPerson.MailSubject",
                                                                },
                                                              ],
                                                              staticClass:
                                                                "form-control w-100",
                                                              attrs: {
                                                                placeholder:
                                                                  "請輸入信件主旨或選擇範本",
                                                              },
                                                              domProps: {
                                                                value:
                                                                  _vm
                                                                    .currentPerson
                                                                    .MailSubject,
                                                              },
                                                              on: {
                                                                input:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    if (
                                                                      $event
                                                                        .target
                                                                        .composing
                                                                    )
                                                                      return
                                                                    _vm.$set(
                                                                      _vm.currentPerson,
                                                                      "MailSubject",
                                                                      $event
                                                                        .target
                                                                        .value
                                                                    )
                                                                  },
                                                              },
                                                            }),
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "text-danger",
                                                                staticStyle: {
                                                                  "font-size":
                                                                    "13px",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      errors[0]
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "form-group" },
                                              [
                                                _c("ValidationProvider", {
                                                  staticClass: "w-100",
                                                  attrs: {
                                                    rules: "required",
                                                    name: "信件內容",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function ({
                                                          errors,
                                                        }) {
                                                          return [
                                                            _c(
                                                              "label",
                                                              {
                                                                attrs: {
                                                                  for: "",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "mark",
                                                                  },
                                                                  [_vm._v("*")]
                                                                ),
                                                                _vm._v(
                                                                  "信件內容： "
                                                                ),
                                                              ]
                                                            ),
                                                            _c("VueEditor", {
                                                              staticStyle: {
                                                                background:
                                                                  "rgb(255, 255, 255)",
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .currentPerson
                                                                    .MailTemplateBody,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.currentPerson,
                                                                      "MailTemplateBody",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "currentPerson.MailTemplateBody",
                                                              },
                                                            }),
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "text-danger",
                                                                staticStyle: {
                                                                  "font-size":
                                                                    "13px",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      errors[0]
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                        ],
                                        2
                                      ),
                                    ]
                                  ),
                                  _c("div", { staticClass: "modal-footer" }, [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-secondary",
                                        attrs: {
                                          type: "reset",
                                          "data-dismiss": "modal",
                                        },
                                      },
                                      [_vm._v(" 取消 ")]
                                    ),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-success",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return handleSubmit(_vm.reArrange)
                                          },
                                        },
                                      },
                                      [_vm._v(" 寄出 ")]
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "temporaryModal",
            tabindex: "-1",
            "data-backdrop": "static",
          },
        },
        [
          _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
            _c("div", { staticClass: "modal-content" }, [
              _vm._m(1),
              _c(
                "div",
                { staticClass: "modal-body" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "temporaryForm",
                      attrs: {
                        "label-position": "top",
                        model: _vm.temporaryForm,
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "姓名",
                            prop: "Name",
                            rules: [
                              {
                                required: true,
                                message: "必填",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.temporaryForm.Name,
                              callback: function ($$v) {
                                _vm.$set(_vm.temporaryForm, "Name", $$v)
                              },
                              expression: "temporaryForm.Name",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "身分證字號/護照號碼",
                            prop: "IdNo",
                            rules: [
                              {
                                required: true,
                                message: "必填",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.temporaryForm.IdNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.temporaryForm, "IdNo", $$v)
                              },
                              expression: "temporaryForm.IdNo",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    attrs: { type: "reset", "data-dismiss": "modal" },
                  },
                  [_vm._v(" 關閉 ")]
                ),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: { type: "reset" },
                    on: {
                      click: function ($event) {
                        return _vm.addArrangeTemporary()
                      },
                    },
                  },
                  [_vm._v(" 儲存 ")]
                ),
              ]),
            ]),
          ]),
        ]
      ),
      _c(
        "transition",
        {
          attrs: {
            name: "custom-classes-transition",
            "enter-active-class": "animated bounceInLeft",
            "leave-active-class": "animated bounceOutRight",
          },
        },
        [
          _vm.isShowDetail
            ? _c("div", { staticClass: "detail-modal" }, [
                _c("div", { staticClass: "detail-modal-inner" }, [
                  _c(
                    "div",
                    { staticClass: "menu" },
                    [
                      _vm.resumeDetail.ArrangeGuid === null
                        ? [
                            _c(
                              "a",
                              {
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    _vm.resumeDetail.ResumeType = "IDL"
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  [
                                    _c("eva-icon", {
                                      attrs: {
                                        name: "person-outline",
                                        fill: "#FFF",
                                      },
                                    }),
                                    _vm._v(" IDL 履歷 "),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _c(
                              "a",
                              {
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    _vm.resumeDetail.ResumeType = "DL"
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  [
                                    _c("eva-icon", {
                                      attrs: {
                                        name: "person-outline",
                                        fill: "#FFF",
                                      },
                                    }),
                                    _vm._v(" DL 履歷 "),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ]
                        : _c("a", [
                            _c(
                              "span",
                              [
                                _c("eva-icon", {
                                  attrs: {
                                    name: "person-outline",
                                    fill: "#FFF",
                                  },
                                }),
                                _vm._v(" 履歷 "),
                              ],
                              1
                            ),
                          ]),
                      _c(
                        "div",
                        {
                          staticClass: "close-show-detail",
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              _vm.isShowDetail = !_vm.isShowDetail
                            },
                          },
                        },
                        [
                          _c("eva-icon", {
                            attrs: {
                              name: "close-circle",
                              fill: "#FFF",
                              width: "50",
                              height: "50",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                  _c(
                    "div",
                    { staticClass: "page-wrap" },
                    [
                      _c(
                        "transition",
                        {
                          attrs: {
                            name: "custom-classes-transition",
                            "enter-active-class": "animated flipInY",
                          },
                        },
                        [
                          _c("perfect-scrollbar", { staticClass: "page" }, [
                            _c(
                              "section",
                              { staticClass: "page-inner" },
                              [
                                _c("div", { staticClass: "title" }, [
                                  _c(
                                    "div",
                                    { staticClass: "item text-center" },
                                    [_vm._v("履歷")]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "item text-right" },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-outline-primary btn-sm",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.$common.downloadResumePDF(
                                                _vm.resumeDetail.ResumeType,
                                                _vm.resumeDetail.ResumeId
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" 下載 PDF ")]
                                      ),
                                    ]
                                  ),
                                ]),
                                _vm.resumeDetail.ResumeType === "IDL"
                                  ? _c("IdlResume", {
                                      attrs: {
                                        ResumeId: _vm.resumeDetail.ResumeId,
                                        ResumeType: "IDL",
                                      },
                                    })
                                  : _vm._e(),
                                _vm.resumeDetail.ResumeType === "DL"
                                  ? _c("DlResume", {
                                      attrs: {
                                        ResumeId: _vm.resumeDetail.ResumeId,
                                        ResumeType: "DL",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ])
            : _vm._e(),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "QrCode",
            visible: _vm.qrCodeDialogVisible,
            width: "400px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.qrCodeDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "text-center" },
            [_c("qrcode-vue", { attrs: { value: _vm.QRCode, size: "350" } })],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.qrCodeDialogVisible = false
                    },
                  },
                },
                [_vm._v("關閉")]
              ),
            ],
            1
          ),
        ]
      ),
      _c("ResponseDataModal", {
        attrs: {
          successfulList: _vm.successMessage,
          failedList: _vm.failMessage,
        },
      }),
      _c("PreviewMailModal", {
        attrs: { type: "interview", mail: _vm.previewData },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header" }, [
      _c("h5", { staticClass: "modal-title" }, [_vm._v("取消")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header" }, [
      _c("h5", { staticClass: "modal-title" }, [_vm._v("新增臨時到廠")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }